import { Main } from './components/containers';

/**
 * Página de listado de órdenes de trabajos extra
 */
const ExtraWorkOrdersList = () => {
  return <Main />;
};

export default ExtraWorkOrdersList;
